export const isLocal = (): boolean => {
    const { hostname } = window.location;
  
    return (
      hostname.includes('0.0.0.0') ||
      hostname.includes('local') ||
      hostname.includes('127.0.0.1')
    );
  };